import React from 'react';
import { Box, Typography, Paper, Backdrop, LinearProgress } from '@mui/material';
import { FaHandHoldingMedical } from "react-icons/fa";

const SplashScreen = ({ progress = 0 }) => (
  <Backdrop
    open={true}
    sx={{
      backgroundColor: 'background.default',
      zIndex: 1000,
      flexDirection: 'column',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: 180,
          height: 180,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'primary.main',
          borderRadius: '50%',
          marginBottom: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* <FaHandHoldingMedical
          style={{
            fontSize: '3.5rem',
            color: 'white',
          }}
        /> */}
        <span class="loader"></span>
      </Paper>

      <Box sx={{ width: '80%', maxWidth: 300 }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 6,
            borderRadius: 3,
            backgroundColor: 'rgba(255,255,255,0.3)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: 'primary.main',
            },
          }}
        />
      </Box>
    </Box>
    <Typography
      sx={{
        color: 'primary.main',
        mb: 1,
        fontSize: '1.25rem',
        // textShadow: '0px 2px 4px rgba(0,0,0,0.2)',
        letterSpacing: 1,
        position: 'absolute',
        bottom: 50,
        fontFamily: 'Kanit',
        fontWeight: '900',
        textTransform: 'uppercase'
      }}
    >
      Easy Health Digital Solutions
    </Typography>
  </Backdrop>
);

export default SplashScreen; 